import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../../core/shared/widget/service/widget.factory";


@Component({
    selector: 'ei-structure-field-basic-component',
    templateUrl: 'ei-structure-field-basic.component.html',
    standalone: false
})
export class EiStructureFieldBasicComponent implements OnInit, OnChanges {

    @Input() structureFieldId: number;

    initialized: boolean;
    basicWidget: WidgetData;

    private builtForId: number;

    ngOnInit() {
        this.initComponent();
        this.initialized = true;
    }

    initComponent() {
        if (!this.structureFieldId) {
            return;
        }
        // Skip rebuild on every change-detection pass; only rebuild when the parent id actually changes.
        if (this.basicWidget && this.builtForId === this.structureFieldId) {
            return;
        }
        this.basicWidget = WidgetFactory.createWidgetEntityData(
            'ei.structureField.basic.data.widget',
            'Strukturfeld',
            'ei.EiStructureField',
            this.structureFieldId
        );
        this.builtForId = this.structureFieldId;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
        this.initComponent();
    }

}
